import Marquee from "react-fast-marquee";

const words = ["Stampa", "Allestimenti", "Insegne", "Ledwall", "Wrapping", "Vetrofanie", "Siti Web", "Branding"];

export const MarqueeBand = () => (
  <div className="py-10 border-y border-zinc-200 bg-zinc-50 overflow-hidden" data-testid="marquee-band" aria-hidden="true">
    <Marquee speed={45} gradient={false} pauseOnHover>
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-medium text-4xl sm:text-6xl tracking-tight text-black mx-6 uppercase">{w}</span>
          <span className="text-4xl sm:text-6xl font-display text-black mx-2 select-none">–</span>
        </span>
      ))}
    </Marquee>
  </div>
);
